export const WIDGET_IDS = {
  PERSONAL_INFO: "personalInfo",
  PATIENT_MORPHOLOGY: "patientMorphology",
  MEDICAL_IMAGE: "medicalImage",
  CLINICAL_HISTORY: "clinicalHistory",
  REPORTS: "reports",
  // ACTIVITY_TRACKING: "activityTracking",
  PAIN_ASSESMENT: "painAssessment",
  // SURVEY_RESULTS: "surveyResults",
  NOT_IMPLEMENTED: "notImplemented",
};
